<mat-form-field appearance="outline" bmTheme="find-tracks-select">
  <mat-label>{{ lg.sortTrackBy.mood.label }}</mat-label>
  <mat-select [(value)]="moodId" (selectionChange)="filterTracksByMood($event)">
    <mat-option [value]="'all'">{{ lg.sortTrackBy.mood.allMoodsOption }}</mat-option>
    @for (mood of getMoods(); track mood) {
      <mat-option [value]="mood.id">
        {{ mood.title }}
      </mat-option>
    }
  </mat-select>
</mat-form-field>
